import { memo } from 'react';
import { EApplicantOfferPGKeys } from 'types';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';

const getFormattedStatus = (status?: string): string => (status === 'Completed' ? 'Unconditional' : status);

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const result = getFormattedStatus(cellProps.row.status || cellProps.row.applicationStatus) || UNKNOWN_VALUE;
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {result}
    </Flex>
  );
});
export const StatusColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.STATUS,
    name: 'Status',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
